export const OPEN_MODAL = 'OPEN_MODAL';

export const WELL_GRAPH_LIST = 'WELL_GRAPH_LIST';
export const WELL_GRAPH_LIST_SUCCESS = 'WELL_GRAPH_LIST_SUCCESS';
export const WELL_GRAPH_LIST_ERROR = 'WELL_GRAPH_LIST_ERROR';
export const WELL_GRAPH_UPDATE_DATA = 'WELL_GRAPH_UPDATE_DATA';